import { Box, Menu, SkeletonText, SvgIcon, Tooltip } from '@volue/wave-react';
import React, { useState } from 'react';

import { useActions } from '@/overmind';
import type { GUID } from '@/overmind/effects/auth';

import { useSelectableTenants } from '../hooks/useSelectableTenants.hook';
import { useTenantState } from '../hooks/useTenantState.hook';

export function TenantPicker() {
  const [isMenuOpen, setMenuOpen] = useState<boolean>(false);

  const selectableTenants = useSelectableTenants();

  const { isSelected, tenantName } = useTenantState();

  const { changeTenantTo } = useActions().tenants;

  const select = (id: GUID) => {
    changeTenantTo(id);
    setMenuOpen(false);
  };

  return (
    <Menu isOpen={isMenuOpen} onIsOpenChange={setMenuOpen}>
      <Menu.Trigger
        as="button"
        className="sidebarNav-item ofH"
        css={{ color: '$colorAccent70' }}
      >
        <Tooltip
          content={`Tenant: ${tenantName}`}
          placement="top"
          className="parentZIndex1100"
        >
          <div className="dF aiC fg1">
            <SvgIcon size="small" iconName="group" className="mRm mLs" />
            <Box css={{ minWidth: '10ch' }} className="fg1 fs1 txtL">
              <SkeletonText
                width="10ch"
                isLoaded={isSelected}
                className="txtTruncate"
              >
                <span>{tenantName}</span>
              </SkeletonText>
            </Box>
            <SvgIcon
              className="mHs"
              iconName={isMenuOpen ? 'chevronUp' : 'chevronDown'}
            />
          </div>
        </Tooltip>
      </Menu.Trigger>
      <Menu.Content className="parentZIndex1100">
        <Menu.RadioGroup value={tenantName}>
          {selectableTenants.map(([organizationName, tenants], index) => (
            <Menu.Group key={organizationName}>
              <Menu.Label>{organizationName}</Menu.Label>
              {tenants.map(tenant => (
                <Menu.RadioItem
                  onClick={() => select(tenant.id)}
                  key={tenant.id}
                  value={tenant.name}
                >
                  {' '}
                  {tenant.name}
                </Menu.RadioItem>
              ))}
              {index !== selectableTenants.length - 1 && (
                <Menu.Separator key={`${organizationName}-sep`} />
              )}
            </Menu.Group>
          ))}
        </Menu.RadioGroup>
      </Menu.Content>
    </Menu>
  );
}
